/**
 * The different section types.
 *
 * NOTE: the order of these is the order the corresponding form sections appear in the UI.
 */
export enum SectionType {
  OutputFileName = 'OUTPUT_FILENAME',
  OutputFileType = 'OUTPUT_FILETYPE',
  DocxTemplate = 'DOCX_TEMPLATE',
  HtmlDocxTemplate = 'HTML_DOCX_TEMPLATE',
  File = 'FILE',
  FixedFile = 'FIXED_FILE',
  Merge = 'MERGE_DOCX',
  Certification = 'CERTIFICATION',

  // DocMerge
  DocMergeTemplateSection = 'DOCMERGE_TEMPLATE_SECTION',
}
